module.exports = __webpack_public_path__ + "static/mysa-mattress-2-321693538303726451fb8fc73c11bbb4.png";